import { createSelector } from '@ngrx/store';
import * as businessGroupNamesState from '../reducers';
import * as businessGroupNamesReducer from '../reducers/business-group-names.reducer';

export const selectBusinessGroupNames = createSelector(
  businessGroupNamesState.GetBusinessGroupNamesState,
  businessGroupNamesReducer.getBusinessGroupNames
);
